<mat-form-field
  [subscriptSizing]="input.subscriptSizing"
  [appearance]="input.appearance"
>
  <mat-chip-grid #chipList aria-label="">
    @for (chip of chipsInput; track chip) {
      <mat-chip-row
        color="warn"
        [removable]="removable"
        (removed)="remove(chip)"
        [highlighted]="chip.valid === false"
      >
        {{ chip.label }}
        @if (removable) {
          <mat-icon matChipRemove>cancel</mat-icon>
        }
      </mat-chip-row>
    }
    <input
      placeholder="{{ this.input.placeholder | parse: context | async }}"
      [matChipInputFor]="chipList"
      [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
      [matChipInputAddOnBlur]="addOnBlur"
      (matChipInputTokenEnd)="add($event)"
    />
  </mat-chip-grid>
  @if (firstFormControlError; as error) {
    <mat-error>
      {{ error.errorMessage | parse: context | async }}
    </mat-error>
  }
</mat-form-field>
